import { mode } from '@chakra-ui/theme-tools';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';

const inputs = {
  transition: '0.3s all !important',
  borderRadius: '10px !important',
  border: '1px solid #9FABCB  !important',
  p: '26px 16px !important',
  fontSize: '16px !important',
  fontWeight: '400 !important',
  _hover: {
	  boxShadow: '0 0 0 0.5px #099BFF !important',
  },
  _focus:{
	  boxShadow: '0 0 0 0.5px #099BFF !important',
	  borderColor: '#099BFF !important'
  }
};

const tag = {
  p: '3px 0',
  borderRadius: '20px',
  textAlign: 'center',
  mt: '6px',
  maxW: '110px',
  fontSize: '14px !important'
};

export const globalStyles = {
  colors: {
    blue: {
      10: '#eaecf0',
      100: '#061a43',
    },
    red: {
      0: '#FFE1DF',
    },
    grey: {
      10: '#bdbdbd',
      100: '#bdbdbd'
    }
  },
  styles: {
    global: (props) => ({
      body: {
        bg: mode('white', '#03050C')(props), //# 03050C
        fontFamily: '\'Inter\', sans-serif',
        position: 'relative'
      },
      '*': {
        overflow: 'hidden',
        outline: 'none !important',
        userSelect: 'none !important',
        '-webkit-user-select': 'none !important',
        '-ms-user-select': 'none !important',
        '-moz-user-select': 'none !important',
        '-webkit-tap-highlight-color': 'transparent !important'
      },
      html: {
        fontFamily: '\'Inter\', sans-serif'
      },
	    select: {
	    	...inputs,
	    	h: 'unset !important',
	    	p: '16px 15px !important'
	    },
	    input: {
	    	...inputs
	    },
      'select.select-md': {
        ...inputs,
        h: 'unset !important',
        p: '8px 16px !important'
      },
      '.select-filter': {
        ...inputs,
        h: '37px !important',
        p: '8px 16px !important',
        bg: mode('white !important', 'rgba(5, 11, 33, 0.54) !important')(props),
        borderColor: mode('white !important', 'rgba(5, 11, 33, 0.54) !important')(props),
        _hover: {
          boxShadow: 'unset !important',
          borderColor: mode('white !important', 'rgba(5, 11, 33, 0.54) !important')(props),
        },
        _focus:{
          boxShadow: 'unset !important',
          borderColor: mode('white !important', 'rgba(5, 11, 33, 0.54) !important')(props),
        }
      },
	    'input.input-invalid': { borderColor: 'red !important' },
      'select.input-invalid': { borderColor: 'red !important' },
	    '.input-invalid': { 
	    	'input': { borderColor: 'red !important' },
	    },
	    'label.input-invalid': { color: 'red !important' },
	    'button.freeze': { pointerEvents: 'none' },
	    'button[disabled]': {
	    	opacity: '0.2 !important',
	    	bg: 'transparent !important',
  	    color: mode('#9FABCB !important', '#9FABCB !important')(props),
  	    _hover: {
          bg: 'transparent !important',
        },
        _active: {
          bg: 'transparent !important',
        },
	    },
      '.freeze': { pointerEvents: 'none', opacity: '0.3' },
      '.displayNone': { display: 'none' },
      '.freeze-iframe': { pointerEvents: 'none', opacity: '0.7' },
	    '.input-error': {
	    	top: 0,
        left: 0,
        zIndex: 2,
        position: 'absolute',
        bg: mode('white', '#1A243E')(props),
        pointerEvents: 'none',
        mx: '14px !important',
        px: '4px !important',
        my: '15px !important',
        transformOrigin: 'left top',
        color: 'red !important',
      	fontWeight: '400',
      	fontSize: '14px',
				transform: 'scale(0.85) translateY(35px)',
				lineHeight: 'normal !important'
	    },
	    '.hidden': { display: 'none !important' },
      '.chakra-radio': {
        pb: '10px',
        '.chakra-radio__control': {
          w: '22px',
          h: '22px',
          borderColor: '#9FABCB',
          borderWidth: '0.11em',
          mr: '5px',
          _focus: {
            boxShadow: 'unset !important'
          },
          '&[data-hover]': {
            bg: '#1870EC !important',
            borderColor: '#1870EC !important'
          },
        },
      },
      '.chakra-modal__overlay': {
        bg: 'unset !important'
      },
      '.chakra-modal__content-container': {
        transition: '1s all',
        bg: '#000000bf',
        p: '0',
        m: '0',
        overflowX: 'hidden',
        '.modal__achievements': {
          background: '#00000085 !important'
        },
  	    '.chakra-modal__content': {
          p: '40px 20px 0 20px !important',
  	    	borderRadius: '0px !important',
          background: 'transparent',
          boxShadow: 'unset !important',
          overflow: 'visible',
          mt: '0px !important'
          //borderTop: '1px solid rgb(255 255 255 / 23%)',
  	    },
  	    '.chakra-modal__header': {
  	    	fontSize: '32px !important',
  	    	fontWeight: '700 !important',
  	    	color: mode('#1B1B1F !important', 'white !important')(props),
  	    	pb: '0px !important'
  	    },
        '.modal__simple': {
          '*': {
            transition: '0.3s all',
            overflow: 'visible !important'
          },
          '.chakra-modal__header': {
            p: '0px',
            pb: '0px',
          },
          '.chakra-modal__body': {
            padding: '0px !important',
          },
          '.chakra-modal__close-btn': {
            borderColor: mode('blue.50', '#F5E417')(props),
            boxShadow: 'inset 0 0px 8px #dd8a23, 0px 0px 6px #dd8a23 !important',
            borderWidth: '1px',
            outline: 'none !important',
            w: '44px',
            h: '44px',
            m: '109px 10px 0px 0',
            borderRadius: '10px',
            bg: 'transparent',
            'svg': {
              w: '14px',
              h: '14px',
              color: 'white',
            },
            _hover: {
              bg: 'transparent',
            },
            _active: {
              bg: 'transparent',
            },
            _focus: {
              outline: 'none !important',
            }
          },
          '&.modal__game_result': {
            mt: '10%',
            p: 0,
            border: 'unset',
            '.modal__game_result': {
              _after: {
                content: '""',
                position: 'absolute',
                top: '0',
                left: '0',
                background: '#099BFF',
                filter: 'blur(200px)',
                width: '100%',
                height: '100%'
              }
            },
            ' > div': {
              _before: {
                  content: '""',
                  width: '2px',
                  height: '216px',
                  top: '0',
                  left: '0',
                  position: 'absolute',
                  zIndex: '9',
                  background: 'linear-gradient(0deg, rgba(56, 169, 225, 0.00) 0%, #38A9E1 50%, rgba(56, 169, 225, 0.00) 100%)',
                  transform: 'translate(0%, 50%)'
              },
              _after: {
                  content: '""',
                  width: '2px',
                  height: '216px',
                  top: '0',
                  right: '0',
                  position: 'absolute',
                  zIndex: '9',
                  background: 'linear-gradient(0deg, rgba(56, 169, 225, 0.00) 0%, #38A9E1 50%, rgba(56, 169, 225, 0.00) 100%)',
                  transform: 'translate(0%, 50%)'
              }
            },
            '.chakra-modal__body': {
              padding: '20px 22px 100px 22px !important',
              border: '1px solid rgba(255, 255, 255, 0.10) !important',
              bg: 'rgba(5, 11, 33, 0.80) !important',
              borderRadius: '10px !important',
              backdropFilter: 'blur(8px) !important',
              _before: {
                  content: '""',
                  position: 'absolute',
                  top: '0',
                  left: '-170px',
                  width: '190px',
                  height: '100%',
                  background: 'linear-gradient(0deg, #1884FF 0%, #1884FF 100%), #36A1D7',
                  opacity: '0.6',
                  filter: 'blur(25px)',
                  borderRadius: '100%'
              },
              _after: {
                  content: '""',
                  position: 'absolute',
                  top: '0',
                  right: '-170px',
                  width: '190px',
                  height: '100%',
                  background: 'linear-gradient(0deg, #1884FF 0%, #1884FF 100%), #36A1D7',
                  opacity: '0.6',
                  filter: 'blur(25px)',
                  borderRadius: '100%'
              }
            },
            '.modal__game_result-img': {
              width: '100%', 
              position: 'absolute', 
              top: 0, 
              transform: 'translate(0%, -16%) scale(1.5)',
              zIndex: 1
            }
          },
          'header': {
            paddingTop: '71px !important'
          }
        },
        '.modal__purple': {
          background: 'linear-gradient(180deg, black 40%, transparent)',
          '.chakra-modal__close-btn': {
            borderColor: mode('blue.50', '#c344ff')(props),
            boxShadow: 'inset 0 0px 8px #880FD5, 0px 0px 6px #880FD5 !important',
          },
        },
        '.modal__info': {
          '.chakra-modal__close-btn': {
            borderColor: mode('blue.50', '#6C60F3')(props),
            boxShadow: 'inset 0 0px 8px #3B31F2, 0px 0px 6px #3B31F2 !important',
          },
        },
        '.modal__blue': {
          '.chakra-modal__close-btn': {
            borderColor: mode('blue.50', '#6C60F3')(props),
            boxShadow: 'inset 0 0px 8px #3B31F2, 0px 0px 6px #3B31F2 !important',
          },
        },
        '.modal__attention': {
          bg: '#111111cc !important',
          bottom: '0 !important',
          top: 'unset !important',
          m: '0 !important',
          borderRadius: '0 !important',
          height: '100%'
        },
        '.overflowHidden': {
          overflow: 'hidden !important'
        }
      },
	    '.PhoneInputCountry' : {
	    	position: 'absolute !important',
		    p: '21px 0 0px 20px !important',
		    zIndex: '9 !important'
	    }, 
	    '.PhoneInputInput': { 
	    	p: '15px 20px 15px 70px !important',
        bg: 'transparent',
	    	_focusVisible: {
				  outline: 'none !important'
        } 
	    },
      '.PhoneInputCountryIcon': { fontSize: '14px', boxShadow: 'unset' },
      '.PhoneInputCountrySelectArrow': { 
        margin: '-4px 0 0 8px', 
        fontSize: '23px', 
        color: '#1f2733 !important',
        opacity: '1'
      },
      '.PhoneInput': { mb: '24px' },
      '.PhoneInputCountryIcon--border': { boxShadow: 'unset !important' },
      '.vi__container': {
        w: 'unset',
        m: '22px auto 27px auto',
        input: {
          border: 'unset !important',
          _hover: {
					  boxShadow: 'unset !important',
          },
          _focus:{
					  boxShadow: 'unset !important',
					  borderColor: 'unset !important'
          }
        },
        '.vi__character': {
				    borderRadius: '50px',
				    maxWidth: '50px',
				    fontSize: '24px',
				    minWidth: '50px',
				    borderColor: 'gray.50',
				    color: 'gray.800'
        },
        '.character--inactive': { background: 'transparent !important', color: 'gray.800' },
        '.vi__character--filled': { borderColor: 'blue.200', color: 'gray.800', boxShadow: '0 0 0 0.5px #1870EC !important'},
        '.character--selected': { outline: 'unset !important', color: 'gray.800', borderColor: 'blue.200', boxShadow: '0 0 0 0.5px #1870EC !important' },
      },
      '.code-container': {
        w: 'unset',
        m: '22px auto 27px auto',
        input: {
          border: 'unset !important',
          _hover: {
            boxShadow: 'unset !important',
          },
          _focus:{
            boxShadow: 'unset !important',
            borderColor: 'unset !important'
          }
        },
        '.vi__character': {
            borderRadius: '50px',
            minW: '64px',
            maxW: '64px',
            maxH: '64px',
            minH: '64px',
            fontSize: '24px',
            borderColor: 'blue.50',
            borderWidth: '0px',
            color: mode('gray.800', 'white')(props),
            padding: '6px',
            bg: 'transparent', 
            boxShadow: mode('0 0 0 1px #D8E2FF !important', '0 0 0 1px rgba(255, 255, 255, 0.20)')(props),
        },
        '.character--inactive': { 
          bg: 'transparent !important', 
        },
        '.vi__character--filled': { 
          borderColor: '#099BFF', 
          boxShadow: '0 0 0 1px #099BFF !important',
        },
        '.character--selected': { 
          outline: 'unset !important', 
          borderColor: '#099BFF',
        },
        '.input-freeze-code' : {
          bg: mode('gray.100', '#2a4079')(props),
          boxShadow: '0 0 0 1px #099BFF !important', 
          pointerEvents: 'none'
        }
      },
      '.input-invalid-code': {
        '.vi__character': {
          bg: mode('#FFF8F7', 'transparent')(props),
          borderColor: 'red.200',
          boxShadow: '0 0 0 0.5px red !important' 
        }
      },
      '.circle-object': {
        w: '40px',
        h: '40px',
        borderRadius: '20px',
        color: 'white !important',
        fontWeight: '600 !important',
        p: '8px 15px'
      },
      '.boxObject-active': { 
        bg: mode('blue.200', 'linear-gradient(126deg, #099BFF 32.5%, #6CC3FF 81.54%)')(props),
        color: 'white !important'
      },
      '.boxObject-inactive': { 
        boxShadow: mode('0 0 0 1px #C5C6D0', '0 0 0 1px rgba(255, 255, 255, 0.20)')(props),
        bg: mode('transparent', '#162B5A !important')(props),
      },
      '.games-list': {
        '.game-item': {
          w: '40px',
          mr: '8px'
        },
        'img': {
          p: 0,
          border: '0.5px solid transparent',
          w: '40px',
          h: '40px',
          borderRadius: '30px',
          zIndex: '9',
          maxW: 'unset',
          m: '5px 0 0 0',
          objectFit: 'cover'
        },
        '.active': {
          'img': {
            borderRadius: '30px',
            w: '40px',
            h: '40px',
            mt: '6px',
            p: '7px',
          },
        }
      },
      '.settings-tabs': {
        borderWidth: '0px !important',
        a: {
          transition: '0.2s all',
          width: 'max-content',
          fontSize: '16px',
          fontWeight: '600',
          color: mode('gray.800', '#9FABCB')(props),
          pb: '4px',
          borderColor: 'rgba(0,0,0,0) !important',
          borderBottom: '1px',
          mb: '16px',
          '&:last-child':{
            mb: '0px'
          },
          _hover: {
            color: '#099BFF !important'
          }
        },
        '.settings-tab-active': {
           color: '#099BFF',
           borderColor: '#099BFF !important',
           borderBottom: '1px'
        },
        '&.safer-gambling-tabs': {
          gap: '24px',
          a: {
            '&:last-child':{
              mb: '16px'
            },
          }
        }
      },
      '.tag-deposit-active': {
         bg: '#10337F !important',
         border: '1px solid #099BFF !important'
      },
      '.tag-date-deposit-active': {
        bg: '#0279CB !important'
      },
      '.notify-success': {
        bg: mode('green.50', 'rgba(34, 151, 63, 0.20)')(props),
        'p': {
          color: mode('#9FABCB', '#57D175')(props)
        },
        'img': {
          bg: '#65d77c',
          borderRadius: '40px'
        }
      }, 
      '.notify-error': {
        bg: mode('red.0', 'rgba(255, 45, 85, 0.20)')(props),
        'p': {
          color: mode('#9FABCB', '#FF6982')(props)
        }
      },
      '.chakra-checkbox__control': {
        w: '20px !important',
        h: '20px !important',
        borderRadius: '5px !important',
        borderColor: '#1870EC !important',
        _hover: {
          outline: 'none !important',
          boxShadow: 'none !important'
        },
        _active: {
          outline: 'none !important',
          boxShadow: 'none !important'
        },
        _focus: {
          outline: 'none !important',
          boxShadow: 'none !important'
        }
      },
      '.chakra-checkbox__control[data-checked]':{
        bg: '#1870EC !important'
      },
      '.winning-ball': {
        bg: '#099BFF !important',
        color: 'white !important',
        fontWeight: '700 !important',
        boxShadow: '0px 4px 8px 0px rgba(41, 58, 190, 0.38), 0px 2px 0px 0px #293ABE !important'
      },
      '.selected-ball': {
        bg: 'linear-gradient(152deg, #34A853 0.67%, #77C01B 39.93%, #34A853 89.58%), #1870EC !important',
        boxShadow: '0px 2px 4px 0px rgba(255, 255, 255, 0.10) inset, 0px 2px 4px 0px rgba(0, 0, 0, 0.10) !important',
        fontWeight: '700 !important',
        color: 'white !important',
        position: 'relative !important',
        fontSize: '20px !important',
        pt: '8px !important',
        _after:{
          content: '""',
          position: 'absolute',
          bg: 'rgba(255, 255, 255, 0.79)',
          filter: 'blur(4.300000190734863px)',
          w: '7px',
          h: '19px',
          transform: 'rotate(49.011deg)',
          left: '9px',
          top: '3px'
        }
      },
      '.chakra-switch__track': {
        _focus: {
          boxShadow: 'unset !important'
        }
      },
      'img.current-avatar': {
        boxShadow: '0 0 0 0.1em #1870EC',
        borderRadius: '30px'
      },
      '.bottombar-page': {
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '24px',
        mr: '8px',
        textDecoration: 'none !important',
        'p': {
          fontSize: '16px',
          fontWeight: '700',
          p: '8px 12px',
        },
        '&.active': {
          bg: 'linear-gradient(126deg, #099BFF 32.5%, #6CC3FF 81.54%)',
          boxShadow: '0px 1px 22.4px 0px rgba(9, 155, 255, 0.60)',
          'path': {
            fill: 'white'
          },
          'p': {
            color: 'white'
          }
        },
      },
      '.active-svg': {
        'path': {
          fill: 'blue.200'
        }
      },
      '.scroll-users-block': {
        position: 'relative',
        _after: {
          content: '""',
          background:  mode('linear-gradient(270deg, #f0f4fd 10%, transparent)', 'linear-gradient(270deg, #04081F 10%, transparent)')(props),
          position: 'absolute',
          w: '50px',
          h: '50px',
          zIndex: 9,
          right: 0
        }
      },
      '.scroll-users':{
        w: '110%', 
        overflowX: 'auto',
        overflowY: 'hidden',
        pointerEvents: 'none',
        whiteSpace: 'nowrap',
        position: 'relative',
        '&::-webkit-scrollbar': {
          height: '0px',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: 'transparent',
        },
      },
      '.context-menu': {
        //bg: '#FAF9FF !important',
        borderRadius: '10px !important',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: '400',
        button: {
          padding: '16px 5px'
        }
      },
      '.chakra-menu__menu-button': {
        _hover: {
          outline: 'none !important',
          boxShadow: 'none !important',
          bg: 'transparent !important'
        },
        _active: {
          outline: 'none !important',
          boxShadow: 'none !important',
          bg: 'transparent !important'
        },
      },
      '.tag-ghost': {
        ...tag
      },
      '.tag-white': {
        ...tag,
        bg: 'white',
        color: '#1870EC !important'
      }, 
      '.tag-blue': {
        ...tag,
        bg: mode('blue.50', 'rgba(24, 112, 236, 0.20)')(props), 
        color: mode('#1870EC !important', '#508DFF !important')(props),
      },
      '.tag-darkblue': {
        ...tag,
        bg: mode('blue.200', '#162B5A')(props),
        color: 'white !important'
      }, 
      '.tag-green': {
        ...tag,
        bg: mode('green.50', 'rgba(34, 151, 63, 0.20)')(props),
        color: mode('#1E7735 !important', '#57D175 !important')(props), 
      }, 
      '.tag-red': {
        ...tag,
        bg: mode('red.75', 'rgba(255, 45, 85, 0.20)')(props), 
        color: mode('#ED1145 !important', '#FF6982 !important')(props),
      },
      '.tag-orange': {
        ...tag,
        bg: mode('#FFF1C5', 'rgba(255, 149, 0, 0.20)')(props),
        color: mode('#E26E00 !important', '#FFB91B !important')(props), 
      },
      '.tag-purple': {
        ...tag,
        bg: mode('#F6EAFD', 'rgba(187, 98, 234, 0.20)')(props), 
        color: mode('#AF52DE !important', '#CE8EF2 !important')(props), 
      },
      '.tag-gray': {
        ...tag,
        bg: '#EFF0FA',
        color: '#50525A !important'
      },
      '.winner-text-color': {
        color: mode('#1E7735 !important', '#34C759 !important')(props), 
        fontSize: '16px !important',
        fontWeight: '600 !important',
        'p': {
          color: mode('#1E7735 !important', '#34C759 !important')(props), 
          fontSize: '16px !important',
          fontWeight: '600 !important'
        }
      },
      '.loser-text-color': {
        color: '#C8170D !important',
        fontSize: '16px !important',
        fontWeight: '600 !important'
      },
      '.full-width-chart': {
        w: '100% !important'
      },
      '.filter-active': {
        color: '#099BFF !important',
        borderBottom: '1px solid #099BFF'
      },
      '.hover-animation': {
        transition: '0.2s all',
        overflow: 'hidden',
        '*': {
          transition: '0.2s all',
        },
        _hover: {
          ' > div:last-child': {
            opacity: 1,
            zIndex: 3
          }
        }
      },
      '.filter-date': {
        p: '0 0 16px 0 !important',
        w: '303px !important',
        overflow: 'hidden',
        button: {
          p: '10px 24px !important',
          _hover: {
            bg: '#10337F !important'
          }
        },
        '.react-datepicker-wrapper': {
          p: '8px',
          w: '100%'
        },
        '.filter-date-placeholder': {
          left: '24px',
          top: '17px',
          color: '#9FABCB'
        },
        input: {
          w: '100%',
          h: '40px !important',
          p: '6px 16px !important',
          bg: 'rgba(5, 11, 33, 0.54)',
          mb: '4px',
          borderRadius: '10px !important',
          borderColor: 'unset !important',
          borderWidth: '0 !important',
          color: '#6B7795',
          _hover: {
            outline: 'none !important',
            boxShadow: 'none !important'
          },
          _active: {
            outline: 'none !important',
            boxShadow: 'none !important',
          },
          _focus: {
            outline: 'none !important',
            boxShadow: 'none !important'
          }
        }
      }
    })
  }
};
